import moment from 'moment';

export const formatDate = (
  date: string | Date | moment.Moment,
  outputFormat: string,
  inputFormat?: string
): string => {
  return moment(date, inputFormat).format(outputFormat);
};
